import { buttonsFirst, buttons, buttonsLast } from '../botones';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StepsTokens {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'TOKENS',
        text: `
            En esta página puede encontrar toda la información relativa a los tokens que tiene registrados para la utilizar la API REST en este momento.<br><br>
            Puede utilizar los botones de "acción" de la última columna para cambiar el nombre, la fecha de caducidad o eliminarlo.
        `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_150',
          on: 'bottom' as const,
        },
        title: 'NUEVO TOKEN',
        text: `
            Si quiere crear un nuevo token utilice este botón. Se le solicitará un nombre y una fecha de caducidad.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'MENÚ DE ACCIONES',
        text: `
            Desde el menú <b>⋮</b> puede <b>exportar</b> los registros en formato CSV (compatible con Excel, Google Sheets, LibreOffice...) y <b>limpiar los filtros</b> activos de la tabla.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_400',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS',
        text: `
            Al pulsar sobre cada columna se ordenarán los registros de forma ascendente o descendente.  También puede reordenar las columnas arrastrándolas a la posición deseada manteniendo pulsado el botón del ratón.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-datatable-tbody',
          on: 'bottom' as const,
        },
        title: 'DATOS',
        text: `
            En la parte central de la tabla tendrá acceso a los registros.  En la última columna se muestran las acciones que puede realizar sobre cada registro.
        `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-paginator',
          on: 'bottom' as const,
        },
        title: 'PAGINADOR',
        text: `
            Puede cambiar de página utilizando el paginador y el número de registros mostrados en cada página.
        `,
        buttons: buttonsLast,
      },
    ];
  }
}
